

interface LoadingNumberProps {
    loadingSuccess:()=>void;
    lang?:any,
    number?:number
}

export default function LoadingNumber(props:LoadingNumberProps) {
    const {loadingSuccess, lang, number} = props;
  // const [number, setNumber] = useState<number>(0);
  // const refNumber = useRef<any>(0);
  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     if (refNumber.current >= 98) {
  //       window.clearInterval(interval);
  //       loadingSuccess();
  //     }
  //     refNumber.current+=1
  //     setNumber((number) => number + 1);
  //   }, 40);

  //   return()=>{
  //       window.clearInterval(interval);
  //   }
  // }, []);
  return (
    <div className="wrap-loading-number">
      {/* <div className="content-loading-number">{number > 9 ? number : `0${number}`.slice(-2)}%</div> */}
      <div className="content-loading-number">
        {lang?.loading_fn || "Loading"}{" "}
        {number > 9 ? number : `0${number}`.slice(-2)}%
      </div>
    </div>
  );
}
